import { useCallback, useMemo } from 'react';

import { useGetUserScopes } from '/client/apiserv';

type ScopeMap = { [key: string]: true };

export const useScopedPermissions = () => {
	const { data, isFetching } = useGetUserScopes({
		query: {
			staleTime: 1000 * 60 * 5 // Five minutes
		}
	});

	const scopeMap = useMemo(() => {
		return (
			data?.reduce((map, scope) => {
				map[scope] = true;
				return map;
			}, {} as ScopeMap) ?? {}
		);
	}, [data]);

	const hasScope = useCallback(
		(scopes: string[]) => {
			return scopes.every((scope) => scopeMap[scope] ?? false);
		},
		[data]
	);

	return {
		hasScope,
		isFetching
	};
};
